import { TwContainer } from '~/lib/TwContainer';
import { Card } from '@mantine/core';
import { ContactForm } from '~/components/ContactForm';

export const SectionFive = () => {
	return (
		<section className="bg-secondary">
			<TwContainer className="py-20 px-8">
				<div className={'mx-auto grid md:grid-cols-2 gap-8'}>
					<h1 className="font-semibold text-gray-600 md:text-7xl text-2xl my-auto max-w-sm font-saira">
						WANT US TO <span className={'text-red-500 font-saira'}>CALL</span> YOU?
					</h1>
					<Card className={'p-10'}>
						<ContactForm
							className={'gap-4 flex-col flex'}
							textInputProps={{
								variant: 'filled',
							}}
						/>
					</Card>
				</div>
			</TwContainer>
		</section>
	);
};
